import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const CFTrendsGraph = ({ data = {} }) => {
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "line",
      height: window.screen.height - window.screen.height / 1.4,
      toolbar: {
        show: false,
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: [],
      labels: {
        enabled: false,
      },
      lineWidth: 0,
    },
    yAxis: {
      min: null,
      max: null,
      tickAmount: 5,
      title: "",
      plotLines: [
        {
          value: 1,
          color: "#D4D4D4",
          width: 1,
          zIndex: 2,
        },
      ],
      plotBands: [],
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
        },
      },
    },
    legend: {
      align: "center",
      verticalAlign: "top",
      alignColumns: false,
      itemStyle: {
        fontSize: "11px",
        fontWeight: "600",
      },
      symbolPadding: 0,
      symbolRadius: 0,
    },
    tooltip: {
      formatter: function () {
        return `${this.series.name}: ${this.y}`;
      },
    },
    series: [
      {
        name: "Actual",
        data: [],
        color: "#0077B6",
        marker: {
          enabled: false,
        },
      },
      {
        name: "Control Limit",
        data: [],
        color: "#D6EEDD",
        marker: {
          enabled: false,
        },
      },
    ],
  });

  useEffect(() => {
    const actualValue = data?.actualValue || 0;
    const lowerLimit = data?.lowerLimit || 0;
    const upperLimit = data?.upperLimit || 0;

    const actualValues = [actualValue, actualValue, actualValue, actualValue];

    const yAxisMin = Math.min(lowerLimit, actualValue);
    const yAxisMax = Math.max(upperLimit, actualValue);

    setChartOptions((prevOptions) => ({
      ...prevOptions,
      yAxis: {
        ...prevOptions.yAxis,
        min: yAxisMin,
        max: yAxisMax,
        plotBands: [
          {
            from: lowerLimit,
            to: upperLimit,
            color: "#D6EEDD",
          },
        ],
      },
      series: [
        {
          ...prevOptions.series[0],
          data: actualValues,
        },
        {
          ...prevOptions.series[1],
          data: [lowerLimit, upperLimit],
        },
      ],
    }));
  }, [data]);

  return (
    <div id="chart">
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default CFTrendsGraph;
